import RelayClient from '@relay/client';
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { registrations } from '../../.relay/registrations';

const relay = new RelayClient(registrations, async (registration, props, container) => {
  return new Promise(async (resolve) => {
    const { default: Component } = await registration.import();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let reactComponent: any = React.createElement(Component, props as any);

    // if development wrap the component in a React.StrictMode
    if (process.env.NODE_ENV === 'development') {
      reactComponent = React.createElement(React.StrictMode, undefined, reactComponent);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    hydrateRoot(container, reactComponent as any);

    resolve();
  });
});

relay.initialise();
